// const blogCarouselSlider = new Swiper('.upcoming-events-slider', {
//   loop: false,
//   spaceBetween: 20,
//   slidesPerView: 1.1,
//   scrollbar: {
//     el: ".swiper-scrollbar",
//     hide: true,
//   },
//   breakpoints: {
//     650: {
//       spaceBetween: 20,
//       slidesPerView: 2,
//     },
//     992: {
//       spaceBetween: 20,
//       slidesPerView: 2,
//     },
//     1200: {
//       slidesPerView: 2,
//       spaceBetween: 40,
//     },
//   },
// });

new Swiper (".marquee-text-slider", {
  autoplay: {
    enabled: true,
    delay: 0,
    pauseOnMouseEnter: false,
    disableOnInteraction: true,
  },
    centeredSlides: true,
    loop: true,
    navigation: false,
    noSwipingClass: 'swiper-slide',
    slidesPerView: 'auto',
    spaceBetween: 30,
    speed: 4000,
});

document.addEventListener("DOMContentLoaded", () => {
  const overviewSections = document.querySelectorAll(".tabs-container");
  overviewSections.forEach(section => {
    const tabButtons = section.querySelectorAll(".tab-button");
    const contents = section.querySelectorAll(".tab-content");
    const images = section.querySelectorAll(".supplement-facts-right-img");
    const tabSelect = section.querySelector("#tabs-select");
    function activateTab(target) {
      tabButtons.forEach(btn =>
        btn.classList.toggle("active", btn.getAttribute("data-target") === target)
      );
      contents.forEach(content =>
        content.classList.toggle("active", content.id === target)
      );
      images.forEach(img => {
        const imgTab = img.querySelector("img")?.dataset.tab;
        img.classList.toggle("active", imgTab === target);
      });
      if (tabSelect) tabSelect.value = target;
    }
    tabButtons.forEach(button => {
      button.addEventListener("click", () => {
        const target = button.getAttribute("data-target");
        activateTab(target);
      });
    });
    if (tabSelect) {
      tabSelect.addEventListener("change", () => {
        activateTab(tabSelect.value);
      });
    }
  });
});


// // acccordion start
(function Accordion() {
  const triggers = document.querySelectorAll('[data-toggle="collapse"]');
  // store active toggle per parent selector (e.g. "#accountAccordions")
  const activeByParent = new Map();
  triggers.forEach(trigger => {
    const targetSel = trigger.dataset.target;
    const content = document.querySelector(targetSel);
    if (!content) return;
    trigger.collapseTarget = content;
    // initial active set
    const parentSel = content.dataset.parent || null;
    if (content.classList.contains("is-active")) {
      if (parentSel) activeByParent.set(parentSel, trigger);
    }
    trigger.addEventListener("click", e => {
      e.preventDefault();
      toggle(trigger);
    });
    content.addEventListener("transitionend", e => {
      if (e.propertyName === "height" && content.classList.contains("is-active")) {
        content.style.height = "auto";
      }
    });
  });
  function toggle(trigger) {
    const content = trigger.collapseTarget;
    const parentSel = content.dataset.parent || null;
    if (content.classList.contains("is-active")) {
      close(trigger);
      if (parentSel && activeByParent.get(parentSel) === trigger) {
        activeByParent.delete(parentSel);
      }
      return;
    }
    // close only within SAME parent group
    if (parentSel) {
      const activeToggle = activeByParent.get(parentSel);
      if (activeToggle && activeToggle !== trigger) close(activeToggle);
      activeByParent.set(parentSel, trigger);
    }
    open(trigger);
  }
  function close(trigger) {
    const content = trigger.collapseTarget;
    // if height is auto, set to pixel first
    content.style.height = content.scrollHeight + "px";
    requestAnimationFrame(() => {
      content.style.height = "0px";
      content.classList.remove("is-active");
    });
    trigger.classList.remove("is-active");
  }
  function open(trigger) {
    const content = trigger.collapseTarget;
    content.style.height = "0px";
    content.classList.add("is-active");
    trigger.classList.add("is-active");
    requestAnimationFrame(() => {
      content.style.height = content.scrollHeight + "px";
    });
  }
})();



const stepSwiper = new Swiper('.testimonials-slider', {
  loop: true,
  spaceBetween: 20,
  slidesPerView: 1,   
  navigation: {
    nextEl: '.testimonials-button-next',
    prevEl: '.testimonials-button-prev',
  },
  pagination: {
    el: ".testimonials-pagination",
    clickable: true,
  },
  breakpoints: {
    750: {
      slidesPerView: 1.4,  
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 2.3,  
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3.25,  
      spaceBetween: 20,
    },
  },
});

const howToWork = new Swiper(".extended-contents", {
  spaceBetween: 0,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: ".extended-pagination",
    clickable: true,
  },
  thumbs: {
    swiper: howToWorkTab,
  },
});

const testimonialsFeaturedIcons = new Swiper(".tfi-slider", {
  slidesPerView: "auto",
  slidesPerGroup: 3,
  spaceBetween: 40,
  freeMode: true,
  watchSlidesProgress: true,
  pagination: {
    el: ".tfi-pagination",
    clickable: true,
  },
  breakpoints: {
    750: {
      slidesPerView:5,  
      spaceBetween: 20,
    },
    992: {
      slidesPerView:5,  
      spaceBetween:20,
    },
  },
});

var ffswiper = new Swiper(".ffsSwiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: false,
    loop: true,

    pagination: {
        el: ".ff-pagination",
        clickable: true,
    },

    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        }
    }
});



const sectionFaqTabsSlider = new Swiper(".section-faq-tabs-slider", {
  spaceBetween: 10,
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
});


const sectionFaqLowerSlider = new Swiper(".section-faq-lower-slider", {
  spaceBetween: 0,
  effect: "fade",
  fadeEffect: { crossFade: true },
  allowTouchMove: false,
  thumbs: {
    autoScrollOffset: 1,
    swiper: sectionFaqTabsSlider,
  },
});


sectionFaqLowerSlider.on('slideChange', function () {
  const index = sectionFaqLowerSlider.activeIndex + 1;
  document.querySelectorAll('.section-faq-right-img').forEach(img => {
    img.classList.remove('active');
  });
  const matchImg = document.querySelector(`.section-faq-right-img[data-item="${index}"]`);
  if (matchImg) {
    matchImg.classList.add('active');
  }
});
